import { YesNoSelection } from "../../data/Fleet/YesNoSelection";
import { ContractType } from "../../data/HR/ContractType";
import { DeliveryUnit } from "../../data/HR/DeliveryUnit";
import { PayFrequency, PayFrequencyEnum } from "../../data/HR/PayFrequency";
import { validateAndFormatChildrenDetails } from "../../helpers/employeeChildrenValidation";
import { employeeGenderOptions } from "../../data/HR/EmployeeGender";

export const employeeFieldConfiguration = [
  {
    name: "firstName",
    label: "First Name",
    type: "text",
    validation: {
      required: "First name is required",
      minLength: {
        value: 1,
        message: "First name must be at least 5 characters long",
      },
      maxLength: {
        value: 100,
        message: "First name must not exceed 100 characters",
      },
    },
  },
  {
    name: "lastName",
    label: "Last Name",
    type: "text",
    validation: {
      required: "Last name is required",
      minLength: {
        value: 1,
        message: "Last name must be at least 5 characters long",
      },
      maxLength: {
        value: 100,
        message: "Last name must not exceed 100 characters",
      },
    },
  },
  {
    name: "nickname",
    label: "Nickname",
    type: "text",
  },
  {
    name: "gender",
    label: "Gender",
    type: "select",
    options: employeeGenderOptions,
  },
  {
    name: "position",
    label: "Position",
    type: "text",
    validation: {
      required: "Position is required",
      minLength: {
        value: 1,
        message: "Position must be at least 5 characters long",
      },
      maxLength: {
        value: 100,
        message: "Position must not exceed 100 characters",
      },
    },
  },
  {
    name: "legalPosition",
    label: "Legal Position",
    type: "text",
    validation: {
      maxLength: {
        value: 200,
        message: "Legal Position must not exceed 200 characters",
      },
    },
  },
  {
    name: "department",
    label: "Department",
    type: "text",
    validation: {
      required: "Department is required",
      minLength: {
        value: 1,
        message: "Department must be at least 5 characters long",
      },
      maxLength: {
        value: 100,
        message: "Department must not exceed 100 characters",
      },
    },
  },
  {
    name: "reportsToId",
    label: "Reports To",
    type: "combo",
    dataKey: "reportsTo",
    validation: {
      required: "Reports To is required",
    },
  },
  {
    name: "contractType",
    label: "Contract Type",
    type: "select",
    options: ContractType,
    validation: {
      required: "Contract Type is required",
    },
  },
  {
    name: "payFrequency",
    label: "Pay Frequency",
    type: "select",
    options: PayFrequency,
    validation: {
      required: "Pay Frequency is required",
    },
  },
  {
    name: "employer",
    label: "Employer",
    type: "text",
  },
  {
    name: "startDate",
    label: "Start Date",
    type: "date",
    validation: {
      required: "Start Date is required",
    },
  },
  {
    name: "terminationDate",
    label: "Termination Date",
    type: "date",
  },
  {
    name: "email",
    label: "Email",
    type: "text",
    validation: {
      required: "Email is required",
      pattern: {
        value: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
        message: "Enter a valid email address",
      },
    },
  },
  {
    name: "phoneNumber",
    label: "Phone Number",
    type: "text",
    validation: {
      required: "Phone Number is required",
    },
  },
  {
    name: "workPhoneNumber",
    label: "Work Phone Number",
    type: "text",
  },
  {
    name: "isMarried",
    label: "Is Married *",
    type: "select",
    options: YesNoSelection,
    validation: {
      validate: (value: any) =>
        (value !== "" && value !== null && value !== undefined) ||
        "Marital status is required",
    },
  },
  {
    name: "childrenCount",
    label: "Children Count",
    type: "number",
    validation: {
      required: "Children count is required",
      min: {
        value: 0,
        message: "Children count cannot be negative",
      },
    },
  },
  {
    name: "childrenSexes",
    label: "Children Sexes (comma or space separated)",
    type: "text",
    placeholder: "e.g. male female male",
    validation: {
      validate: (value: string, formValues: any) => {
        const { isValid, message } = validateAndFormatChildrenDetails(
          formValues.childrenCount,
          value
        );

        return isValid || message || "Invalid children details";
      },
    },
  },
  {
    name: "birthDate",
    label: "Birth Date",
    type: "date",
    validation: {
      required: "Birth Date is required",
    },
  },
  {
    name: "secondLevelManager",
    label: "Second Level Manager",
    type: "combo",
    dataKey: "secondLevelManager",
  },
  {
    name: "isManager",
    label: "Is Manager *",
    type: "select",
    options: YesNoSelection,
    validation: {
      validate: (value: any) =>
        (value !== "" && value !== null && value !== undefined) ||
        "Is Manager is required",
    },
  },
  {
    name: "deliveryUnit",
    label: "Delivery Unit",
    type: "select",
    options: DeliveryUnit,
    validation: {
      required: "Delivery Unit is required",
    },
  },
  {
    name: "employeeId",
    label: "Employee ID",
    type: "text",
    validation: {
      required: "EmployeeId is required",
      minLength: {
        value: 1,
        message: "Employee must be at least 1 characters long",
      },
      maxLength: {
        value: 16,
        message: "Department must not exceed 16 characters",
      },
    },
  },
];

export const employeeInitialValues = {
  firstName: "",
  lastName: "",
  position: "",
  legalPosition: "",
  gender: "",
  department: "",
  reportsToId: null,
  contractType: "",
  payFrequency: PayFrequencyEnum.Monthly,
  employer: "",
  startDate: "",
  terminationDate: "",
  email: "",
  phoneNumber: "",
  nickname: "",
  workPhoneNumber: "",
  isMarried: "",
  childrenCount: 0,
  childrenSexes: "",
  birthDate: "",
  secondLevelManager: null,
  isManager: "",
  deliveryUnit: "",
  employeeId: "",
};

export const makeFieldConfigDynamic = (fields: any[]) => {
  return fields.map((field) => {
    return field;
  });
};
